import { useEffect, useState, useCallback } from 'react';

const useScreenWidthQuery = (): [number] => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const handleResize = useCallback(() => {
    setInnerWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return [innerWidth];
};
export default useScreenWidthQuery;
